import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  permissions: 'Permissions',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.permissions],
  endpoints: {
    getPermissions: {
      providesTags: [{ type: TAG_TYPES.permissions, id: 'PERMISSIONS' }],
    },
  },
})

export const { useGetPermissionsQuery } = api
